/**
 * ============================================================
 * VA DESIGN · JavaScript del tema
 * ------------------------------------------------------------
 * Guardar como assets/va-design.js y enlazarlo en theme.liquid
 * justo antes de </body>:
 *
 *   <script src="{{ 'va-design.js' | asset_url }}" defer></script>
 *
 * Contiene:
 *   1. Header sólido al hacer scroll
 *   2. Deslizador para el filtro de precio
 * ============================================================
 */

(function () {
  'use strict';

  /* ============================================================
     1. HEADER
     Vuelve sólido el encabezado al bajar. Antes vivía en línea
     dentro de theme.liquid; aquí queda mejor.
     ============================================================ */

  function header() {
    var cuerpo = document.body;
    if (!cuerpo.classList.contains('va-header-transparente')) return;

    var pinta = function () {
      cuerpo.classList.toggle('va-solido', window.scrollY > 70);
    };
    window.addEventListener('scroll', pinta, { passive: true });
    pinta();
  }

  /* ============================================================
     2. DESLIZADOR DE PRECIO
     ------------------------------------------------------------
     Dawn entrega dos campos numéricos para el rango de precio.
     Aquí se les añade una barra con dos manijas que los controla,
     y se ocultan los campos originales.

     Los campos siguen siendo la fuente de verdad: el deslizador
     escribe en ellos y dispara el evento que Dawn ya escucha, así
     que el filtrado sigue funcionando igual sin tocar el tema.
     ============================================================ */

  function deslizadorPrecio(caja) {
    if (caja.dataset.vaListo) return;

    // Dawn usa campos de TEXTO, no numéricos, y guarda el máximo en
    // data-max con formato "78,400.00". Hay que leerlo de ahí.
    var min = caja.querySelector('input[name="filter.v.price.gte"]');
    var max = caja.querySelector('input[name="filter.v.price.lte"]');
    if (!min || !max) return;

    var crudo = max.dataset.max || min.dataset.max || max.placeholder || '';
    var tope = Number(String(crudo).replace(/[^0-9.]/g, ''));
    if (!tope || !isFinite(tope)) return;
    tope = Math.ceil(tope);

    caja.dataset.vaListo = '1';

    /* --- se arma la barra --- */
    var barra = document.createElement('div');
    barra.className = 'va-rango';
    barra.innerHTML =
      '<div class="va-rango__pista"><span class="va-rango__activo"></span></div>' +
      '<input type="range" class="va-rango__min" min="0" max="' + tope + '" step="1">' +
      '<input type="range" class="va-rango__max" min="0" max="' + tope + '" step="1">' +
      '<div class="va-rango__valores">' +
        '<span class="va-rango__desde"></span>' +
        '<span class="va-rango__hasta"></span>' +
      '</div>';

    caja.insertBefore(barra, caja.firstChild);
    caja.classList.add('va-con-rango');

    var rMin = barra.querySelector('.va-rango__min');
    var rMax = barra.querySelector('.va-rango__max');
    var activo = barra.querySelector('.va-rango__activo');
    var vDesde = barra.querySelector('.va-rango__desde');
    var vHasta = barra.querySelector('.va-rango__hasta');

    /* --- formato de moneda, corto para que quepa --- */
    function pesos(n) {
      return '$' + Math.round(n).toLocaleString('es-MX');
    }

    function pinta() {
      var a = Number(rMin.value);
      var b = Number(rMax.value);
      activo.style.left = (a / tope * 100) + '%';
      activo.style.right = (100 - b / tope * 100) + '%';
      vDesde.textContent = pesos(a);
      vHasta.textContent = b >= tope ? pesos(tope) + '+' : pesos(b);
    }

    /* --- estado inicial: lo que ya tengan los campos --- */
    function limpia(v) {
      var n = Number(String(v).replace(/[^0-9.]/g, ''));
      return isFinite(n) ? n : null;
    }

    rMin.value = limpia(min.value) !== null && min.value !== '' ? limpia(min.value) : 0;
    rMax.value = limpia(max.value) !== null && max.value !== '' ? limpia(max.value) : tope;
    pinta();

    /* --- las manijas no se cruzan --- */
    function ajusta(cual) {
      var a = Number(rMin.value);
      var b = Number(rMax.value);
      if (a > b) {
        if (cual === 'min') rMin.value = b;
        else rMax.value = a;
      }
      pinta();
    }

    rMin.addEventListener('input', function () { ajusta('min'); });
    rMax.addEventListener('input', function () { ajusta('max'); });

    /* --- al soltar, se escriben los campos reales y se filtra --- */
    function aplica() {
      var a = Number(rMin.value);
      var b = Number(rMax.value);

      min.value = a > 0 ? a : '';
      max.value = b < tope ? b : '';

      // Dawn escucha 'change' en el formulario de filtros
      min.dispatchEvent(new Event('change', { bubbles: true }));
      max.dispatchEvent(new Event('change', { bubbles: true }));
    }

    ['change', 'pointerup', 'touchend', 'keyup'].forEach(function (ev) {
      rMin.addEventListener(ev, aplica);
      rMax.addEventListener(ev, aplica);
    });

    /* --- si Dawn actualiza los campos, la barra se sincroniza --- */
    [min, max].forEach(function (c) {
      c.addEventListener('change', function () {
        rMin.value = min.value !== '' ? (limpia(min.value) || 0) : 0;
        rMax.value = max.value !== '' ? (limpia(max.value) || tope) : tope;
        pinta();
      });
    });
  }

  function buscaPrecios() {
    document
      .querySelectorAll('price-range, .facets__price, .facets-vertical .facets__price')
      .forEach(deslizadorPrecio);
  }

  /* ============================================================
     ARRANQUE
     Los filtros de Dawn se vuelven a dibujar al filtrar, así que
     hay que reconstruir el deslizador cuando eso pase.
     ============================================================ */

  function arranca() {
    header();
    buscaPrecios();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }

  // Dawn reemplaza el bloque de filtros al aplicar uno
  var observador = new MutationObserver(function () { buscaPrecios(); });
  var contenedor = document.getElementById('main-collection-filters') || document.body;
  observador.observe(contenedor, { childList: true, subtree: true });
})();
